import { metaMask } from '@wagmi/connectors';
import { createConfig, createStorage, http, injected } from '@wagmi/core';
import { environment } from '../../environments/environment';

if (!environment.PROVIDERS || typeof environment.PROVIDERS.sepolia !== 'string' || environment.PROVIDERS.sepolia.trim() === '') {
  throw new Error('PROVIDERS.sepolia is required to be a non-empty string in the configuration.');
}

export const config = createConfig({
  chains: [environment.SUPPORTED_NETWORK[0]],
  connectors: [
    metaMask({
      dappMetadata: {
        name: 'Aqlx',
        url: environment.PROJECT_URL,
      },
    }), injected()
  ],
  storage: createStorage({ storage: window.localStorage }),
  transports: {
    [environment.SUPPORTED_NETWORK[0].id]: http(environment.PROVIDERS.sepolia)
  },
});